import React from "react";
import Button from "./Button";

const FootInfo = () => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-7">
        <a
          href="/assets/docs/web-of-care-data-updates.docx"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            title="UPDATES"
            className="py-[5px] px-2 !max-w-[131px] !min-w-[131px]"
          />
        </a>
        <a
          href="https://drive.google.com/file/d/1KMRtxuuswOSlU4vfeenInacNaUn4zQCx/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue underline"
        >
          <Button
            title="REFERENCES"
            className="py-[5px] px-2 !max-w-[131px] !min-w-[131px]"
          />
        </a>
      </div>

      <p className="text-black text-xs font-medium leading-relaxed border-t-[0.5px] border-black pt-3">
        The data on this website may have updates or additional relevant data.
        View new or updated data by selecting the UPDATES button.
      </p>
    </div>
  );
};

export default FootInfo;
